module.exports = __webpack_public_path__ + "static/media/featured_work_web.33f954c4.png";